import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wid-arrow-right",
  "use": "icon-wid-arrow-right-usage",
  "viewBox": "0 0 5 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 5 7\" id=\"icon-wid-arrow-right\"><g><path d=\"M0,7L2.95947,7L5,3.25L2.95947,0L0,0L2.04053,3.25L0,7Z\" fill=\"#366CFE\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol